<div *ngIf="entity">
  <h2>{{ viewContext.entityNamePlural | titlecase}} / {{ entity.name | uppercase }}</h2>

  <div>
    <form (ngSubmit)="onSubmit()" [formGroup]="form">

      <div *ngFor="let question of questions" class="form-row">
        <div class="form-group col-xl-10">
          <app-question [question]="question" [form]="form"></app-question>
        </div>
      </div>
    </form>
  </div>

  <qm-groups-selection
    [groupIds]="selectedGroupsFromRest"
    (idsChanged)="groupIdsChanged($event)"
  >
  </qm-groups-selection>

  <app-buttons [buttons]="getButtonsMeta()"
               (buttonPressed)="controlButtonPressed($event)"
               [targetSelected]="true">
  </app-buttons>
</div>
